import {hitType} from "../../analytics.helper";
import {portfolioActionTypes} from "../../../../_constants/actions/analytics/portfolioActionTypes";
import {sourceActionTypes} from "../../../../_constants";

// UTILITY-HELPERS ##########################################################

// generic portfolio event that accepts the event and user identifier
const genericPortfolioEvent = (event, values = {}) => {
	return {
		event: event,
		hitType: hitType.EVENT,
		values: values,
	};
};

// EVENTS ##########################################################

// collapse media list - click event
const collapseMediaList = (action) => genericPortfolioEvent(portfolioActionTypes.COLLAPSE_MEDIA_LIST, action.identifier);

// expand media list - click event
const expandMediaList = (action) => genericPortfolioEvent(portfolioActionTypes.EXPAND_MEDIA_LIST, action.identifier);

// activate source - click event
const activateSource = () => genericPortfolioEvent(sourceActionTypes.ACTIVATE_SOURCE_REQUEST);

// deactivate source - click event
const deActivateSource = () => genericPortfolioEvent(sourceActionTypes.DEACTIVATE_SOURCE_REQUEST);

// copy url - click event
const copyUrl = () => genericPortfolioEvent(portfolioActionTypes.COPY_URL);

// source edit start - click event
const sourceRenameStart = () => genericPortfolioEvent(portfolioActionTypes.SOURCE_RENAME_TITLE_START);

// source edit cancel - click event
const sourceRenameCancel = () => genericPortfolioEvent(portfolioActionTypes.SOURCE_RENAME_TITLE_CANCEL);

// source edit success
const sourceRenameSuccess = () => genericPortfolioEvent(portfolioActionTypes.SOURCE_RENAME_TITLE_SUCCESS);

// EVENT-MAPPINGS ##########################################################

// portfolio events mappings
export const portfolioEventsMap = {
	[portfolioActionTypes.COLLAPSE_MEDIA_LIST]          : collapseMediaList,
	[portfolioActionTypes.EXPAND_MEDIA_LIST]            : expandMediaList,
	[sourceActionTypes.ACTIVATE_SOURCE_REQUEST]         : activateSource,
	[sourceActionTypes.DEACTIVATE_SOURCE_REQUEST]       : deActivateSource,
	[portfolioActionTypes.COPY_URL]                     : copyUrl,
	[portfolioActionTypes.SOURCE_RENAME_TITLE_START]    : sourceRenameStart,
	[portfolioActionTypes.SOURCE_RENAME_TITLE_CANCEL]   : sourceRenameCancel,
	[portfolioActionTypes.SOURCE_RENAME_TITLE_SUCCESS]  : sourceRenameSuccess,
};